import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
    selector: 'cv-integration-mongo-logs-cell-renderer',
    templateUrl: './integration-mongo-logs-cell-renderer.component.html',
    styleUrls: ['./integration-mongo-logs-cell-renderer.component.scss']
})
export class IntegrationMongoLogsCellRendererComponent implements ICellRendererAngularComp {
    value: string;
    params: ICellRendererParams;
    constructor(
        private modalService: NgbModal,
    ) { }

    refresh(): boolean {
        return false;
    }

    agInit(params: ICellRendererParams): void {
        this.value = params.value;
        this.params = params;
    }

    openModal(templateRef) {
        const modalRef = this.modalService.open(templateRef, {
            backdrop: 'static',
            keyboard: false,
            centered: true,
        });

        return modalRef;
    }
}
